import React, { useState } from 'react';

import { connect } from 'react-redux';

import {
    Grid,
    GridNoRecords,
    GridColumn as Column,
} from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';

import BobLoadingMask from '../../../components/BobLoadingMask';

import * as classes from './EquipmentEnergyGrid.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const SiteEnergyGrid = ({
    bobLoading,
    data,
    entity,
    hasInitialized,
    workbookModeEnabled,
    ...props
}) => {
    const [dataState, setDataState] = useState(initialDataState);
    const [pageable] = useState({ pageSizes: true });

    const onDataStateChange = e => {
        setDataState(e.dataState);
    };

    const columns = [
        {
            field:      'site',
            title:      'Site',
            filter:     'text',
            id:         'siteName',
            width:      'auto',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 0,
            primaryKey: true
        },
        {
            field:      'buildingType',
            title:      'Building Type',
            filter:     'text',
            width:      200,
            id:         'buildingType',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 3
        },
        {
            field:      'location',
            title:      'Location',
            filter:     'text',
            width:      150,
            id:         'location',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 4
        },
        {
            field:      'totalEnergyUse',
            title:      'Total Energy Use',
            filter:     'text',
            width:      170,
            id:         'totalEnergyUse',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 5
        },
        {
            field:      'energyPerCoolingDegreeday',
            title:      'Energy Use / Cooling Degree Day',
            filter:     'text',
            width:      250,
            id:         'energyPerCoolingDegreeday',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 6
        },
        {
            field:      'energyPerHeatingDegreeday',
            title:      'Energy Use / Heating Degree Day',
            filter:     'text',
            width:      250,
            id:         'energyPerHeatingDegreeday',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 7
        },
        {
            field:      'cost',
            title:      'Cost   ',
            filter:     'text',
            width:      150,
            id:         'cost',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 8
        },
        {
            field:      'energyTarget',
            title:      'Energy Use Target',
            filter:     'text',
            width:      170,
            id:         'carbon',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 9
        },
        {
            field:      'deltaToTarget',
            title:      'Delta to Target',
            filter:     'text',
            width:      170,
            id:         'deltaToTarget',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 9
        },
        {
            field:      'deltaToPrevPeriod',
            title:      'Delta to Prev Period',
            filter:     'text',
            width:      200,
            id:         'deltaToPrevPeriod',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 9
        },
    ];

    const renderCell = props => {
        switch (props.field) {
            case 'deltaToTarget':
            case 'deltaToPrevPeriod':
                return (
                    <td>
                        <span>
                            {Math.round(((props.dataItem[props.field]) + Number.EPSILON) * 100) / 100}
                        </span>
                        <span>
                            {props.dataItem[props.field] > 0 ? <img className={classes.Icon} src="/assets/images/red_arrow_up.svg" alt="" /> : <img className={classes.Icon} src="/assets/images/green_arrow_down.svg" alt="" />}
                        </span>
                    </td>
                );
            default:
                return (
                    <td>
                        {props.dataItem[props.field]}
                    </td>
                );
        }
    };

    return (
        <div className={classes.Table}>
            <Grid
                sortable={{
                    mode: 'multiple'
                }}
                className={classes.KendoGrid}
                data={kendoProcess(data, dataState)}
                {...dataState}
                onDataStateChange={onDataStateChange}
                pageable={pageable}
                reorderable
                filterable={workbookModeEnabled}
            >
                {
                    !hasInitialized ?
                        <GridNoRecords>
                            {`Loading ${entity} energy records`}
                        </GridNoRecords>
                        :
                        <GridNoRecords>
                            {`No ${entity} energy records`}
                        </GridNoRecords>
                }
                {
                    columns.map((column, index) => (
                        <Column
                            field={column.field}
                            title={column.title}
                            key={index}
                            width={column.width}
                            sortable={column.sortable}
                            filterable={column.filterable}
                            cell={renderCell}
                        />
                    ))
                }
            </Grid>
            {
                bobLoading.includes('FetchEquipmentEnergyData')|| !hasInitialized ?
                    <BobLoadingMask />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => ({
    bobLoading:          state.bob.bobLoading,
    workbookModeEnabled: state.dashboard.workbookModeEnabled
});

export default connect(mapStateToProps, null)(SiteEnergyGrid);
